import api from '../callApi';
import { parseAddressNumber, parseAddressStreet } from '../addressParser';

const apiCompleteVoteRegistration = (
    apiRequestData,
    answerId,
    formData,
    continueOnline,
    values,
    isFromErrorPopup,
    actionCompletedTime
) => {
    const request = {
        ...apiRequestData,
        answerId: answerId,
        notifyResult: formData.getUpdates,
        email: isFromErrorPopup ? values.email || formData.email : formData.email,
        dateOfBirth: isFromErrorPopup
            ? values.dateOfBirth || formData.dateOfBirth
            : formData.dateOfBirth,
        usCitizen: formData.usCitizen,
        hasStateLicense: formData.hasStateLicense,
        name: {
            title: isFromErrorPopup ? values.prefix || formData.prefix : formData.prefix,
            firstName: isFromErrorPopup
                ? values.firstName || formData.firstName
                : formData.firstName,
            lastName: isFromErrorPopup
                ? values.lastName || formData.lastName
                : formData.lastName,
            middleName: isFromErrorPopup
                ? values.middleName || formData.middleName
                : formData.middleName,
            suffix: isFromErrorPopup ? values.suffix || formData.suffix : formData.suffix
        },
        homeAddress: {
            source: 0,
            country: 'US',
            state: isFromErrorPopup
                ? values.stateId || formData.stateId
                : formData.stateId,
            county: isFromErrorPopup ? values.county || formData.county : formData.county,
            city: isFromErrorPopup
                ? values.homeCity || formData.homeCity
                : formData.homeCity,
            zipCode: isFromErrorPopup
                ? values.postalCode || formData.postalCode
                : formData.postalCode,
            street: isFromErrorPopup
                ? values.street || parseAddressStreet(formData.homeAddress)
                : parseAddressStreet(formData.homeAddress),
            streetNo: isFromErrorPopup
                ? values.streetNo || parseAddressNumber(formData.homeAddress)
                : parseAddressNumber(formData.homeAddress),
            unit: isFromErrorPopup ? values.unit || formData.unit : formData.unit,
            streetAddressRaw: isFromErrorPopup
                ? values.streetAddressRaw || formData.homeAddress
                : formData.homeAddress
        },
        phone: isFromErrorPopup ? values.phone || formData.phone : formData.phone,
        sendConfirmationEmails: formData.confirmationEmail,
        optInEmail: formData.getUpdates,
        optInSms: formData.smsUpdates,
        continueOnline: continueOnline,
        idNumber: isFromErrorPopup
            ? values.idNumber || formData.idNumber
            : formData.idNumber,
        firstRegistration: formData.firstRegistration,
        hasMailingAddress: formData.hasMailingAddress,
        changeOfName: formData.changeOfName,
        changeOfAddress: formData.changeOfAddress,
        mailingAddress: {
            source: 0,
            country: 'US',
            state: isFromErrorPopup
                ? values.mailingStateId || formData.mailingStateId
                : formData.mailingStateId,
            county: isFromErrorPopup
                ? values.mailingCounty || formData.mailingCounty
                : formData.mailingCounty,
            city: isFromErrorPopup
                ? values.mailingCity || formData.mailingCity
                : formData.mailingCity,
            zipCode: isFromErrorPopup
                ? values.mailingZipCode || formData.mailingPostalCode
                : formData.mailingPostalCode,
            street: isFromErrorPopup
                ? values.street || parseAddressStreet(formData.mailingAddress)
                : parseAddressStreet(formData.mailingAddress),
            streetNo: isFromErrorPopup
                ? values.streetNo || parseAddressNumber(formData.mailingAddress)
                : parseAddressNumber(formData.mailingAddress),
            unit: isFromErrorPopup
                ? values.mailingUnit || formData.mailingUnit
                : formData.mailingUnit,
            streetAddressRaw: isFromErrorPopup
                ? values.streetAddressRaw || formData.mailingAddress
                : formData.mailingAddress
        },
        prevName: {
            title: isFromErrorPopup
                ? values.prevPrefix || formData.prevPrefix
                : formData.prevPrefix,
            firstName: isFromErrorPopup
                ? values.prevFirstName || formData.prevFirstName
                : formData.prevFirstName,
            lastName: isFromErrorPopup
                ? values.prevLastName || formData.prevLastName
                : formData.prevLastName,
            middleName: isFromErrorPopup
                ? values.prevMiddleName || formData.prevMiddleName
                : formData.prevMiddleName,
            suffix: isFromErrorPopup
                ? values.prevSuffix || formData.prevSuffix
                : formData.prevSuffix
        },
        prevAddress: {
            source: 0,
            country: 'US',
            state: isFromErrorPopup
                ? values.prevStateId || formData.prevStateId
                : formData.prevStateId,
            county: isFromErrorPopup
                ? values.prevCounty || formData.prevCounty
                : formData.prevCounty,
            city: isFromErrorPopup
                ? values.prevHomeCity || formData.prevHomeCity
                : formData.prevHomeCity,
            zipCode: isFromErrorPopup
                ? values.prevZipCode || formData.prevPostalCode
                : formData.prevPostalCode,
            street: isFromErrorPopup
                ? values.street || parseAddressStreet(formData.prevAddress)
                : parseAddressStreet(formData.prevAddress),
            streetNo: isFromErrorPopup
                ? values.streetNo || parseAddressNumber(formData.prevAddress)
                : parseAddressNumber(formData.prevAddress),
            unit: isFromErrorPopup
                ? values.prevUnit || formData.prevUnit
                : formData.prevUnit,
            streetAddressRaw: isFromErrorPopup
                ? values.streetAddressRaw || formData.prevAddress
                : formData.prevAddress
        },
        race: values
            ? values.race ||
              values.raceNotRequired ||
              formData.race ||
              formData.raceNotRequired
            : formData.race || formData.raceNotRequired,
        party: values
            ? values.party ||
              values.partyNotRequired ||
              formData.party ||
              formData.partyNotRequired
            : formData.party || formData.partyNotRequired,
        optInVolunteer: values
            ? values.partnerOptInVolunteer || formData.partnerOptInVolunteer
            : formData.partnerOptInVolunteer,
        actionCompletedTime: actionCompletedTime
    };

    return api
        .post('Widget/CompleteVoteRegistrationAsync', request, { useFingerprint: true })
        .then(response => {
            return response;
        });
};

export default apiCompleteVoteRegistration;
